import {
  GetParticipantsBegin,
  GetParticipantsSuccess,
  GetParticipantsFailure,
  AddParticipantBegin,
  AddParticipantSuccess,
  AddParticipantFailure,
  GetActivitiesBegin,
  GetActivitiessSuccess,
  GetActivitiesFailure
} from "./actions"

import configs from "../../configs"

const fetchParticipants = token => {
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json"
  })

  return fetch(`${configs.api.base}/api/guardian/participants/`, {
    method: "GET",
    headers
  })
}

const fetchActivities = (token, filters) => {
  const headers = new Headers({
    Authorization: `Bearer ${token}`,
    "Content-Type": "application/json"
  })

  let url = "/api/guardian/activity/"

  const checkUrlIncludesFilters = fUrl => {
    let includes = false

    if (fUrl.includes("entity")) includes = true
    if (fUrl.includes("plan_section")) includes = true
    if (fUrl.includes("participant")) includes = true

    return includes
  }

  if (filters) {
    url += "?"

    if (filters.supportTeamActivities) {
      if (checkUrlIncludesFilters(url)) url += "&"
      url += `entity=${filters.supportTeamActivities}`
    }
    if (filters.participantActivities) {
      if (checkUrlIncludesFilters(url)) url += "&"
      url += `entity=${filters.participantActivities}`
    }
    if (filters.section) {
      if (checkUrlIncludesFilters(url)) url += "&"
      url += `plan_section=${filters.section}`
    }
    if (filters.participant) {
      if (checkUrlIncludesFilters(url)) url += "&"
      url += `participant=${filters.participant}`
    }
  }

  return fetch(`${configs.api.base}${url}`, {
    method: "GET",
    headers
  })
}

export const getParticipants = token => {
  return dispatch => {
    dispatch(GetParticipantsBegin())

    return new Promise((resolve, reject) => {
      fetchParticipants(token)
        .then(response => {
          if (response.status === 200) {
            return response.json()
          }
          dispatch(GetParticipantsFailure())
          reject()
          return null
        })
        .then(data => {
          dispatch(GetParticipantsSuccess(data.results))
          resolve(data.results)
        })
        .catch(() => {
          dispatch(GetParticipantsFailure())
          reject()
        })
    })
  }
}

export const addParticipant = (token, participant) => {
  return dispatch => {
    let responseStatus

    dispatch(AddParticipantBegin())

    return new Promise((resolve, reject) => {
      fetch(`${configs.api.base}/api/guardian/request-access/`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json"
        },
        body: JSON.stringify(participant)
      })
        .then(response => {
          responseStatus = response.status
          return response.json()
        })
        .then(data => {
          if (data.message && responseStatus === 200) {
            fetchParticipants(token)
              .then(response2 => {
                if (response2.status === 200) {
                  return response2.json()
                }
                dispatch(AddParticipantFailure())
                reject()
                return null
              })
              .then(data2 => {
                dispatch(AddParticipantSuccess(data2.results))
                resolve()
              })
          } else {
            dispatch(AddParticipantFailure())
            reject(data)
          }
        })
        .catch(() => {
          dispatch(AddParticipantFailure())
          reject()
        })
    })
  }
}

export const getActivities = (token, filters) => {
  return dispatch => {
    dispatch(GetActivitiesBegin())

    return new Promise((resolve, reject) => {
      fetchActivities(token, filters)
        .then(response => {
          if (response.status === 200) {
            return response.json()
          }
          dispatch(GetActivitiesFailure())
          reject()
          return null
        })
        .then(data => {
          dispatch(GetActivitiessSuccess(data.results))
          resolve(data.results)
        })
        .catch(() => {
          dispatch(GetParticipantsFailure())
          reject()
        })
    })
  }
}

export const acceptInvite = (token, id) => {
  return new Promise((resolve, reject) => {
    fetch(`${configs.api.base}/api/guardian/support-team-respond/`, {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json"
      }),
      body: JSON.stringify({
        participant: { id },
        accepts: true
      })
    })
      .then(response => {
        if (response.status === 200) {
          resolve()
          return response.json()
        }

        reject()
        return null
      })
      .catch(() => {
        reject()
      })
  })
}
